/* eslint-disable */
import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import store from '@/store'
import { app } from '@/firebase'
import Home from '@/views/Home.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    },
    // Landing pages of firebase authentication links
    {
        path: '/authentication',
        name: 'Authentication',
        component: () => import(/* webpackChunkName: "authentication" */ '../views/Authentication.vue'),
    },
    {
        path: '/profile',
        name: 'Profile',
        component: () => import(/* webpackChunkName: "profile" */ '../views/Profile.vue'),
    },
    {
        path: '/profile/edit',
        name: 'ProfileEdit',
        component: () => import(/* webpackChunkName: "profile" */ '../views/ProfileEdit.vue'),
    },
    {
        path: '/apply-for-membership',
        name: 'MembershipApply',
        component: () => import(/* webpackChunkName: "profile" */ '../views/MembershipApply.vue'),
    },
    {
        path: '/admin',
        name: 'Admin',
        component: () => import(/* webpackChunkName: "admin" */ '../views/Admin.vue'),
        beforeEnter: (to, from, next) => {
            // login must be done via a page other than /admin
            if (!from.name) next('/')

            const user = app.auth().currentUser
            if (!user) {
                next('/')
                return
            }
            user.getIdTokenResult().then((tokenResult) => {
                const role = tokenResult?.claims?.role
                if (role !== 'admin') next('/')
                else next()
            })
        },
    },
    {
        path: '/blog',
        name: 'BlogList',
        component: () => import(/* webpackChunkName: "blog" */ '../views/BlogList.vue'), 
    },
    {
        path: '/blog/:slug',
        name: 'BlogPost',
        component: () => import(/* webpackChunkName: "blog" */ '../views/PostPage.vue'), 
    },
    {
        path: '/404',
        name: 'NotFound',
        component: () => import(/* webpackChunkName: "common" */ '../views/NotFound.vue'),
    },
    {
        path: '**',
        redirect: '/404',
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})

// Guards
router.beforeEach((to, from, next) => 
    {
        // Register the auth listener on the first loading
        if (!from.name) {
            app.auth().onAuthStateChanged((user) => {
                const userChangePromise = user
                            ? user.getIdTokenResult().then((tokenResult) =>
                            store.dispatch('user/addUser', {
                                id: user.uid,
                                uemail: user.email,
                                name: user.displayName,
                                role: tokenResult.claims.role,
                                updatedAt: tokenResult.claims.updatedAt,
                            })
                        )
                    : store.dispatch('user/deleteUser')
                    
                userChangePromise.then(() => {
                    if (to.name === 'MembershipApply' && (store.state as any).user.user) next('/')
                    if (to.name === 'ProfileEdit' && !(store.state as any).user.user) next('/')
                })
            })
        }

    next()
    })

export default router
